import { NotificationSwitcher } from '@core/model/framework/notifications/notificationSwitcher';
import {
  WaitOnWebauthNotificationGateway,
  WaitOnWebauthNotificationGatewayInput,
  WaitOnWebauthNotificationGatewayOutput,
} from '@core/model/gateway/waitOnWebauthNotificationGateway';
import { inject, injectable } from 'inversify';

@injectable()
export class WaitOnWebauthNotificationSwitcher implements WaitOnWebauthNotificationGateway {
  constructor(@inject(NotificationSwitcher) private notificationSwitcher: NotificationSwitcher) {}

  async awaitNewBankConnection(
    input: WaitOnWebauthNotificationGatewayInput
  ): WaitOnWebauthNotificationGatewayOutput {
    return await this.notificationSwitcher
      .getWaitOnWebauthNotificationGateway()
      .awaitNewBankConnection(input);
  }

  stopWaitingNewBankConnection(): void {
    this.notificationSwitcher.getWaitOnWebauthNotificationGateway().stopWaitingNewBankConnection();
    return;
  }
}
